export default {
    REPORT_PROGRESS: 'REPORT_PROGRESS',
    HIDE_PROGRESS: 'HIDE_PROGRESS'
}